<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0 text-white">
          STAFF LOTTO
        </p>
        <span class="user-status text-success">กำลังใช้งาน</span>
      </div>
      <b-avatar
        size="40"
        variant="light-warning"
        badge
        rounded
        class="badge-minimal"
        badge-variant="success"
      >
        <i class="fas fa-user-circle fa-2x" />
      </b-avatar>
    </template>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BAvatar } from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BNavItemDropdown,
    BAvatar,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
    }
  },
  mounted() {
    this.CheckPage()
  },
  methods: {
    CheckPage() {
      if (this.userData.UserToken) {
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
        localStorage.removeItem('userData')
        this.$ability.update(initialAbility)

        const urlstring = window.location.href
        const url = new URL(urlstring)
        const token = url.searchParams.get('token')
        console.log(url.pathname)
        if (token) {
          localStorage.removeItem('BreakToken')
          localStorage.setItem('BreakToken', btoa(token))
        }
        if (url.pathname === '/demo-login') {
          this.$router.push({ name: 'demo-login' })
        } else {
          // this.$router.push({ path: '/login-next', params: { token: this.$route.query.token } })
          this.$router.push({ name: 'auth-login-next', params: { token: this.$route.query.token } })
        }
      }
    },
    async logout() {
      await this.$http.post('https://api.rmtlotto.com/api/auth/logout')
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>
